import React, { Component } from 'react';
import './Header.css';

import { Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';

import logo from './resources/logo.png';

class Header extends Component {
  render() {
    return (
      <div className="header">
        <img className="header--logo" height="50px" src={logo}/>
        <h1>
          <Link to="/">Bread</Link>
        </h1>
        <div className="header--menu">
          <Button href="/create-project">Create Project</Button>
        </div>
      </div>
    );
  }
}

export default Header;



// WEBPACK FOOTER //
// ./src/Header.js